/* HOC collection toolbar v3: chips, filter drawer, pills, sort, load more, back-button restore, tracking */
(function () {
  if (window.__hocFilterBar) return;
  window.__hocFilterBar = true;

  var STORE_KEY = 'hocGridState';
  var groupState = {};      // which drawer groups the shopper opened/closed
  var controller = null;
  var lastFocus = null;
  var changedInDrawer = false;
  var extraPages = 0;       // how many "Load more" pages are on screen
  var lockY = 0;
  var chipsExpanded = false;  // desktop "+N more" opened in place

  function root() { return document.querySelector('[data-hoc-filter-bar]'); }
  function drawer() { return document.querySelector('[data-hoc-drawer]'); }
  function toolbar() { return document.querySelector('[data-hoc-toolbar]'); }
  function sectionId() { var r = root(); return r ? r.dataset.sectionId : ''; }
  function params() { return new URLSearchParams(window.location.search); }
  function isDesktop() { return window.matchMedia('(min-width: 750px)').matches; }

  /* ---------- tracking: GA4 / GTM dataLayer + Shopify customer events ---------- */
  function track(name, data) {
    var payload = { collection: window.location.pathname };
    if (data) for (var k in data) payload[k] = data[k];
    try {
      window.dataLayer = window.dataLayer || [];
      var dl = { event: 'hoc_' + name };
      for (var j in payload) dl[j] = payload[j];
      window.dataLayer.push(dl);
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('hoc_' + name, payload);
    } catch (e) {}
  }

  /* ---------- chips ---------- */
  function chipRow() { return document.querySelector('.hoc-chips'); }
  function updateFade() {
    var row = chipRow();
    if (!row) return;
    row.parentElement.classList.toggle('has-more', row.scrollLeft + row.clientWidth < row.scrollWidth - 4);
    row.parentElement.classList.toggle('has-less', row.scrollLeft > 4);
  }
  function centerActiveChip() {
    var row = chipRow();
    var active = row && row.querySelector('.hoc-chip[aria-current="true"]');
    if (!row || !active || row.scrollWidth <= row.clientWidth) return;
    var li = active.parentElement;
    row.scrollLeft = Math.max(0, li.offsetLeft - (row.clientWidth - li.offsetWidth) / 2);
  }
  // Desktop: never cut a chip off. The least-used ones hide behind "+N more", which opens the full list in place.
  function setMoreLabel(more, n) {
    var btn = more.querySelector('button');
    if (chipsExpanded) { btn.textContent = 'Less'; btn.setAttribute('aria-expanded', 'true'); }
    else { btn.innerHTML = '+<span data-hoc-more-n>' + n + '</span> more'; btn.setAttribute('aria-expanded', 'false'); }
  }
  function fitChips() {
    var row = chipRow();
    if (!row) return;
    var scroller = row.parentElement;
    var more = row.querySelector('.hoc-chips__more');
    var items = Array.prototype.slice.call(row.children).filter(function (li) { return li !== more; });
    items.forEach(function (li) { li.hidden = false; });
    if (more) more.hidden = true;
    scroller.classList.remove('is-expanded');
    if (isDesktop() && more && row.scrollWidth > row.clientWidth + 1) {
      if (chipsExpanded) {
        scroller.classList.add('is-expanded');
        more.hidden = false;
        setMoreLabel(more, 0);
      } else {
        more.hidden = false;
        var hidable = items.filter(function (li, i) {
          return i > 0 && !li.querySelector('[aria-current="true"]');
        });
        var n = 0;
        for (var i = hidable.length - 1; i >= 0 && row.scrollWidth > row.clientWidth + 1; i--) {
          hidable[i].hidden = true;
          n++;
        }
        if (n === 0) more.hidden = true;
        else setMoreLabel(more, n);
      }
    }
    if (!isDesktop()) centerActiveChip();
    updateFade();
  }

  /* ---------- sticky offset under the theme's sticky header ---------- */
  var header = document.getElementById('shopify-section-header');
  var ticking = false;
  function placeToolbar() {
    ticking = false;
    var tb = toolbar();
    if (!tb) return;
    var top = 0;
    if (header && header.classList.contains('shopify-section-header-sticky') &&
        !header.classList.contains('shopify-section-header-hidden')) {
      top = header.offsetHeight;
    }
    tb.style.setProperty('--hoc-fbar-top', top + 'px');
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(placeToolbar); }
  }, { passive: true });
  if (header && 'MutationObserver' in window) {
    new MutationObserver(placeToolbar).observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  // Desktop: the whole toolbar sticks. Mobile: only the Filter | Sort bar sticks.
  function stickyBar() {
    var c = document.querySelector('.hoc-controls');
    if (c && getComputedStyle(c).position === 'sticky') return c;
    return toolbar();
  }
  function scrollToResults() {
    var bar = stickyBar();
    var target = document.querySelector('.hoc-applied') || document.getElementById('ProductGridContainer');
    if (!bar || !target) return;
    var tTop = target.getBoundingClientRect().top;
    var stick = parseInt(toolbar().style.getPropertyValue('--hoc-fbar-top'), 10) || 0;
    if (tTop < stick + bar.offsetHeight) {
      window.scrollTo({ top: window.pageYOffset + tTop - stick - bar.offsetHeight, behavior: 'smooth' });
    }
  }

  /* ---------- drawer (iOS-safe scroll lock + focus trap) ---------- */
  function lockScroll() {
    lockY = window.pageYOffset;
    document.documentElement.classList.add('hoc-lock');
    var s = document.body.style;
    s.position = 'fixed'; s.top = (-lockY) + 'px'; s.left = '0'; s.right = '0'; s.width = '100%';
  }
  function unlockScroll() {
    document.documentElement.classList.remove('hoc-lock');
    var s = document.body.style;
    s.position = ''; s.top = ''; s.left = ''; s.right = ''; s.width = '';
    window.scrollTo(0, lockY);
  }
  function drawerMode() { var d = drawer(); return (d && d.getAttribute('data-mode')) || 'filter'; }
  // Single-choice sheets (Category, Sort) apply on tap and close themselves.
  function closeSoon() { changedInDrawer = true; setTimeout(closeDrawer, 160); }
  function openDrawer(source, mode) {
    var d = drawer();
    if (!d || !d.hidden) return;
    d.setAttribute('data-mode', mode || 'filter');
    lastFocus = document.activeElement;
    changedInDrawer = false;
    d.hidden = false;
    lockScroll();
    void d.offsetWidth; // force layout so the slide-in transition runs (no rAF: it pauses in background tabs)
    d.classList.add('is-open');
    var close = d.querySelector('.hoc-drawer__close');
    if (close) close.focus({ preventScroll: true });
    track('filter_open', { source: source || 'filter_button', mode: mode || 'filter' });
  }
  function closeDrawer() {
    var d = drawer();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    unlockScroll();
    setTimeout(function () { d.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    if (changedInDrawer) scrollToResults();
  }
  function drawerIsOpen() { var d = drawer(); return d && !d.hidden; }
  function trapFocus(e) {
    var panel = document.querySelector('.hoc-drawer__panel');
    if (!panel) return;
    var els = Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, summary'),
      function (el) { return el.offsetParent !== null || el === document.activeElement; }
    );
    if (!els.length) return;
    var first = els[0], last = els[els.length - 1];
    if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- loading state: thin progress line, no grey overlay ---------- */
  function setBusy(on) {
    var r = root();
    var grid = document.getElementById('ProductGridContainer');
    document.documentElement.classList.toggle('hoc-busy', on);
    if (r) r.classList.toggle('is-loading', on);
    if (grid) grid.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /* ---------- render (filters, sort, chips) ---------- */
  function render(p, push) {
    var r = root();
    if (!r) return;
    p.delete('page');
    p.delete('section_id');
    var qs = p.toString();
    var grid = document.getElementById('ProductGridContainer');
    setBusy(true);

    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;

    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId()) + (qs ? '&' + qs : '');
    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = document.querySelector('.hoc-drawer__body');
        var bodyScroll = body ? body.scrollTop : 0;

        var newGrid = doc.getElementById('ProductGridContainer');
        if (newGrid && grid) grid.innerHTML = newGrid.innerHTML;
        extraPages = 0;

        document.querySelectorAll('[data-hoc-region]').forEach(function (el) {
          var fresh = doc.querySelector('[data-hoc-region="' + el.dataset.hocRegion + '"]');
          if (fresh) el.innerHTML = fresh.innerHTML;
        });

        document.querySelectorAll('.hoc-group').forEach(function (g) {
          if (g.dataset.group in groupState) g.open = groupState[g.dataset.group];
        });
        body = document.querySelector('.hoc-drawer__body');
        if (body) body.scrollTop = bodyScroll;

        if (push) history.pushState({ hoc: qs }, '', window.location.pathname + (qs ? '?' + qs : ''));
        fitChips();
        setBusy(false);
        if (!drawerIsOpen()) scrollToResults();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.search = qs;
      });
  }

  function paramsFromForm(form) {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') p.append(k, v); });
    if (!p.get('sort_by')) {
      var sort = params().get('sort_by');
      if (sort) p.set('sort_by', sort);
    }
    if (p.get('sort_by') === (root() && root().dataset.defaultSort)) p.delete('sort_by');
    return p;
  }

  /* ---------- load more ---------- */
  function loadMore(btn) {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.textContent = 'Loading…';
    var u = new URL(btn.href, window.location.href);
    var page = u.searchParams.get('page');
    u.searchParams.set('section_id', sectionId());
    fetch(u.toString())
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = document.getElementById('product-grid');
        doc.querySelectorAll('#product-grid > li').forEach(function (li) {
          list.appendChild(document.importNode(li, true));
        });
        var oldMore = document.querySelector('[data-hoc-more]');
        var newMore = doc.querySelector('[data-hoc-more]');
        if (oldMore) {
          if (newMore) oldMore.replaceWith(document.importNode(newMore, true));
          else oldMore.remove();
        }
        extraPages++;
        track('load_more', { page: page });
      })
      .catch(function () { window.location.href = btn.href; });
  }

  /* ---------- back button: come back to the same spot after "Load more" ---------- */
  window.addEventListener('pagehide', function () {
    try {
      if (!extraPages) { sessionStorage.removeItem(STORE_KEY); return; }
      var grid = document.getElementById('ProductGridContainer');
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        url: window.location.href, html: grid.innerHTML, y: window.pageYOffset, t: Date.now()
      }));
    } catch (e) {}
  });
  function restoreGrid() {
    var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    var isBack = nav ? nav.type === 'back_forward' : (performance.navigation && performance.navigation.type === 2);
    if (!isBack) return;
    var saved;
    try { saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return; }
    if (!saved || saved.url !== window.location.href || Date.now() - saved.t > 30 * 60 * 1000) return;
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    grid.innerHTML = saved.html;
    extraPages = 1;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var go = function () { window.scrollTo(0, saved.y); };
    go();
    setTimeout(go, 0);
    window.addEventListener('load', go, { once: true });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    var t = e.target;
    if (!t.closest) return;

    var moreChips = t.closest('[data-hoc-more-chips]');
    if (moreChips) {
      e.preventDefault();
      chipsExpanded = !chipsExpanded;
      fitChips();
      track('more_chips', { open: chipsExpanded });
      return;
    }

    var clr = t.closest('[data-hoc-clear]');
    if (clr) {
      e.preventDefault();
      var what = clr.dataset.hocClear;
      var cp = params();
      if (what === 'all') cp = new URLSearchParams();
      else if (what === 'sort') cp.delete('sort_by');
      else if (what === 'cat') cp.delete(root().dataset.param);
      else { var keep = cp.get('sort_by'); cp = new URLSearchParams(); if (keep) cp.set('sort_by', keep); }
      track('clear_' + what, { source: drawerIsOpen() ? 'sheet' : 'box' });
      render(cp, true);
      if (drawerIsOpen()) closeSoon();
      return;
    }

    var opener = t.closest('[data-hoc-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.hocTrack || 'filter_button', opener.dataset.hocMode); return; }
    if (t.closest('[data-hoc-close]')) { e.preventDefault(); closeDrawer(); return; }

    var chip = t.closest('[data-hoc-chip]');
    if (chip) {
      e.preventDefault();
      var param = root().dataset.param;
      var p = params();
      p.delete(param);
      // Desktop: clicking the selected chip again clears the category
      var toggleOff = chip.closest('.hoc-chips') && chip.getAttribute('aria-current') === 'true' && chip.dataset.value;
      if (toggleOff) {
        document.querySelectorAll('[data-hoc-chip]').forEach(function (c) { c.removeAttribute('aria-current'); });
        var allChip = document.querySelector('.hoc-chips [data-hoc-chip][data-value=""]');
        if (allChip) allChip.setAttribute('aria-current', 'true');
        track('clear_cat', { source: 'chip' });
        render(p, true);
        return;
      }
      if (chip.dataset.value) p.append(param, chip.dataset.value);
      document.querySelectorAll('[data-hoc-chip]').forEach(function (c) { c.removeAttribute('aria-current'); });
      chip.setAttribute('aria-current', 'true');
      var inSheet = drawerIsOpen() && chip.closest('.hoc-drawer');
      track('chip_click', { value: chip.dataset.value || 'All', source: inSheet ? 'sheet' : 'chips' });
      render(p, true);
      if (inSheet) { if (drawerMode() === 'cat') closeSoon(); else changedInDrawer = true; }
      return;
    }

    var link = t.closest('[data-hoc-link]');
    if (link) {
      e.preventDefault();
      if (drawerIsOpen()) changedInDrawer = true;
      if (link.dataset.hocTrack) track(link.dataset.hocTrack);
      render(new URL(link.href, window.location.href).searchParams, true);
      return;
    }

    var more = t.closest('[data-hoc-more-btn]');
    if (more) { e.preventDefault(); loadMore(more); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-hoc-sort]')) {
      var label = t.closest('.hoc-ctrl--sort').querySelector('[data-hoc-sort-value]');
      if (label && t.selectedOptions && t.selectedOptions[0]) label.textContent = t.selectedOptions[0].text;
      var p = params();
      p.set('sort_by', t.value);
      track('sort_change', { value: t.value });
      render(p, true);
      return;
    }
    var form = t.closest('[data-hoc-form]');
    if (form) {
      changedInDrawer = true;
      if (t.name === 'sort_by') track('sort_change', { value: t.value, source: 'sheet' });
      var opt = t.closest('.hoc-opt');
      if (opt) opt.classList.toggle('is-checked', !!t.checked);   // instant feedback, older Safari
      if (t.name !== 'sort_by') track('filter_change', { param: t.name, value: t.value, checked: t.type === 'checkbox' ? t.checked : undefined });
      render(paramsFromForm(form), true);
      if (t.name === 'sort_by' && drawerMode() === 'sort') closeSoon();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!drawerIsOpen()) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') trapFocus(e);
    if (e.key === 'Enter' && e.target.closest && e.target.closest('.hoc-price')) {
      e.preventDefault();
      e.target.blur();
    }
  });

  document.addEventListener('toggle', function (e) {
    if (e.target.classList && e.target.classList.contains('hoc-group')) {
      groupState[e.target.dataset.group] = e.target.open;
    }
  }, true);

  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('hoc-chips')) updateFade();
  }, true);

  var resizeTick = false;
  window.addEventListener('resize', function () {
    if (resizeTick) return;
    resizeTick = true;
    requestAnimationFrame(function () { resizeTick = false; fitChips(); });
  });

  window.addEventListener('popstate', function () {
    if (!root()) return;
    render(params(), false);
  });

  function init() {
    restoreGrid();
    fitChips();
    placeToolbar();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitChips);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
